import { render, staticRenderFns } from "./ikids.vue?vue&type=template&id=22c369ac&"
import script from "./ikids.vue?vue&type=script&lang=js&"
export * from "./ikids.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports